import React from 'reactn';
import deliveryHooks from "../../../hooks/deliveryHooks";
import { CurrentStatusPillStyled } from './CurrentStatusPillStyled';

const CurrentStatusPill = ({ trackingItem, selected, hasBackground }) => {

    const { getDeliveryStatusInfo } = deliveryHooks();

    return (
        <CurrentStatusPillStyled hasBackground={hasBackground} selected={selected} statusColor={getDeliveryStatusInfo(trackingItem.lastTrackingEventCategoryId).statusClass}>
            {getDeliveryStatusInfo(trackingItem.lastTrackingEventCategoryId).labelText}
            <span className='color'></span>
        </CurrentStatusPillStyled>
    );
};

export default CurrentStatusPill;